<app-global-modal [config]="config">
  <div class="report" [attr.aria-busy]="loading">
    <div *ngIf="loading" class="report-loading" role="status">
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      Loading payment details…
    </div>

    <div *ngIf="!loading && errorMessage" class="report-error" role="alert">
      <p>{{ errorMessage }}</p>
      <button *ngIf="canRetry" type="button" class="report-retry" (click)="load()">Try again</button>
    </div>

    <ng-container *ngIf="!loading && detail">
      <section class="report-section">
        <h3 class="report-heading">Payouts</h3>
        <p *ngIf="!detail.batch_transactions.length" class="report-empty">No payouts yet</p>
        <ul *ngIf="detail.batch_transactions.length" class="payouts">
          <li *ngFor="let payout of detail.batch_transactions; trackBy: trackPayout" class="payout">
            <dl>
              <dt>Bank Reference</dt>
              <dd class="payout-ref">{{ payout.reference }}</dd>
              <dt>State</dt>
              <dd>{{ payout.state }}</dd>
              <dt>Amount</dt>
              <dd>{{ money(payout.amount) }} {{ payout.currency }}</dd>
            </dl>
          </li>
        </ul>
      </section>

      <section class="report-section">
        <h3 class="report-heading">Description</h3>
        <p class="report-text">{{ detail.description || '—' }}</p>
      </section>

      <section class="report-section report-section--row">
        <div>
          <h3 class="report-heading">Payment Status</h3>
          <p class="report-text">{{ status(detail.payment_status) }}</p>
        </div>
        <div>
          <h3 class="report-heading">Amount Released</h3>
          <p class="report-text">{{ money(detail.amount_released) }}</p>
        </div>
      </section>
    </ng-container>
  </div>
</app-global-modal>
